export class AnalyticsUser {
    name: string;
    email: string;
    customId: string;

    constructor(name: string, email: string, customId: string) {
        this.name = name || '';
        this.email = email;
        this.customId = customId;
    }
}
